const t = "Tryck på Enter för att redigera", r = {
  pressEnterToEdit: t
};
export {
  r as default,
  t as pressEnterToEdit
};
